import sameSexIcon from './icons/same-sex.svg';
import fullIcon from './icons/full.svg';
import limitedIcon from './icons/limited.svg';
import noIcon from './icons/no.svg';
import nonMarriedIcon from './icons/non-married.svg';
import selfEmployedIcon from './icons/self-employed.svg';
import otherFamilyIcon from './icons/other-family.svg';
import noDataIcon from './icons/no-data.svg';

const categoriesMapping = [
    {
        id: 1,
        description: 'Direct employment access for spouse or partner',
        long_description: 'Once the family residence permit is issued, the spouse or partner of a highly-skilled mobile employee can access work directly for any employer.',
        color: '#8bbf2e',
        icon: fullIcon
    },
    {
        id: 2,
        description: 'Spouse or partner can access employment but with some restrictions',
        long_description: 'Once the family residence permit is issued, the spouse or partner of a highly-skilled mobile employee may access employment but there are conditions which need to be met.',
        color: '#3660b7',
        icon: limitedIcon
    },
    {
        id: 3,
        description: 'No access to employment via dependant status',
        long_description: 'Once the family residence permit is issued to the spouse or partner of a highly-skilled mobile employee, employment access is not permitted via the dependant pass.',
        color: '#e74e4e',
        icon: noIcon
    },
    {
        id: 4,
        description: 'Same-sex spouse or partner recognised as dependant',
        long_description: 'In this country there is legislation in place that recognises the same-sex spouse and/or partner as a dependant, including legal recognition of the same-sex couple’s marriage or civil union that took place in another country (where the couple are both third country nationals).',
        color: '#f1cd3a',
        icon: sameSexIcon
    },
    {
        id: 5,
        description: 'Non-married partners recognised as dependant',
        long_description: 'In this country there is legislation in place that recognises non-married partners as dependants, (sometimes referred to as “de facto partners” or couples that are in “durable relationships”).',
        color: '#4c95c5',
        icon: nonMarriedIcon
    },
    {
        id: 6,
        description: 'Spouse or partner can carry out self-employed work',
        long_description: 'Employment authorisation granted to the dependant of a highly-skilled mobile employee includes access to self-employment.',
        color: '#1c2a7c',
        icon: selfEmployedIcon
    },
    {
        id: 7,
        description: 'Other family members also have employment access',
        long_description: 'Family members other than the partner or spouse have access to employment via their dependant pass.',
        color: '#b349d7',
        icon: otherFamilyIcon
    },
    {
        id: 8,
        description: 'No information available to determine dependant work authorisation',
        long_description: 'We do not have the information available to determine dependant work authorisation in this country. ',
        color: '#cccccc',
        icon: noDataIcon
    },
];


export {categoriesMapping};

export const getCategoryById = (id) =>{
    for (const category of categoriesMapping){
        if(category.id === id){
            return category
        }
    }
};